module.exports = __webpack_public_path__ + "static/img/keji1-logo.2b2a05d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/keji1-logo.png
// module id = Gvei
// module chunks = 8